
import DatabasesDetailView from './details/ConnectionDatabases'
import DirectoryServicesDetailView from './details/ConnectionDirectoryServices'
import FormsDetailView from './details/ConnectionForms'
import TextFilesDetailView from './details/ConnectionTextFiles'
import GoogleSpreadsheetsDetailView from './details/ConnectionGoogleSpreadsheets'
import WebServicesDetailView from './details/ConnectionWebServices'
import RestServicesDetailView from './details/ConnectionRestServices'

import ActionDatabaseDetailView from './details/ActionDatabases'
import ActionDirectoryDetailView from './details/ActionDirectoryServices'
import ActionWebServiceDetailView from './details/ActionWebServices'
import ActionRestWebServiceDetailView from './details/ActionRestWebServices'
import ActionFormDetailView from './details/ActionForms'
import ActionGoogleDetailView from './details/ActionGoogleSpreadsheets'
import ActionTextDetailView from './details/ActionTextFiles'
import VectorDBDetailView from './details/ConnectionVectorDB'
import ActionVectorDBDetailView from './details/ActionVectorDB'

import constants from 'Constants';

const connectionViewMap = new Map();
const actionViewMap = new Map();

// Detail views Connections.
connectionViewMap.set(constants.DATABASES_GROUP_TYPE, DatabasesDetailView);
connectionViewMap.set(constants.DIRECTORY_GROUP_TYPE, DirectoryServicesDetailView);
connectionViewMap.set(constants.WEB_GROUP_TYPE, WebServicesDetailView);
connectionViewMap.set(constants.REST_GROUP_TYPE, RestServicesDetailView);
connectionViewMap.set(constants.FORMS_GROUP_TYPE, FormsDetailView);
connectionViewMap.set(constants.TEXT_GROUP_TYPE, TextFilesDetailView);
connectionViewMap.set(constants.GOOGLE_GROUP_TYPE, GoogleSpreadsheetsDetailView);
connectionViewMap.set(constants.VECTORDB_GROUP_TYPE, VectorDBDetailView);

// Detail views Actions.
actionViewMap.set(constants.DATABASES_GROUP_TYPE, ActionDatabaseDetailView);
actionViewMap.set(constants.DIRECTORY_GROUP_TYPE, ActionDirectoryDetailView);
actionViewMap.set(constants.WEB_GROUP_TYPE, ActionWebServiceDetailView);
actionViewMap.set(constants.REST_GROUP_TYPE, ActionRestWebServiceDetailView);
actionViewMap.set(constants.FORMS_GROUP_TYPE, ActionFormDetailView);
actionViewMap.set(constants.GOOGLE_GROUP_TYPE_DETAIL_VIEW, ActionGoogleDetailView);
actionViewMap.set(constants.TEXT_GROUP_TYPE, ActionTextDetailView);
actionViewMap.set(constants.VECTORDB_GROUP_TYPE, ActionVectorDBDetailView);

class DetailViewFactory {
    static getConnectionDetailView(type, config={}){
        console.log('Type from static',type);
        if(!connectionViewMap.has(type)){
            throw 'A view hasn\'t been implemented for this connection type'
        }

        const viewClass = connectionViewMap.get(type);
        return new viewClass(config);
    }

    static getActionDetailView(type, config={}){
        const connectionType = type.slice(0,-1);
        console.log('Type from static',type);
        if(!actionViewMap.has(connectionType)){
            throw 'A view hasn\'t been implemented for this action type'
        }

        const viewClass = actionViewMap.get(connectionType);
        return new viewClass(config);
    }
}

export default DetailViewFactory;